import ApiCustom from "../utils/ApiCustom";

const getNotificationPosts = async () => {
  try {
    const response = await ApiCustom.get("/posts?type=notification");
    return response.data?.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export { getNotificationPosts };
